<template>
    <div class="broker-lead-form">
        <div
            v-if="leadFormTitle"
            class="lead-title"
            v-html="leadFormTitle"
        ></div>
        <div v-if="infoTextShow && user" class="lead-info">
            <i class="iconfont icon-checked"></i>
            <span class="text">{{ $t('md-home-mortgage.leadInfoText') }}</span>
        </div>
        <v-form
            v-else
            :onSubmit="registerSubmit"
            :onSuccess="registerSubmitSuccess"
            :onError="registerSumbitError"
        >
            <input-item
                v-for="(item, index) in items"
                :item="item"
                :key="index"
                :class="item.class"
            ></input-item>
            <input
                class="submit"
                type="submit"
                :aria-label="$t('md-home-mortgage.getMoreInfoAboutMortgage')"
                :value="$t('md-home-mortgage.getMoreInfo')"
                :disabled="disabledBtn"
                :class="{ 'submit-disabled': disabledBtn }"
            />
        </v-form>
        <template v-if="showDisclaimer">
            <teleport v-if="disclaimerTeleportId" :to="disclaimerTeleportId">
                <Disclaimer
                    :color="disclaimerColor"
                    :disclaimerUniqId="disclaimerUniqId"
                    @updateChecked="checked => (disclaimerChecked = checked)"
                    :btnText="$t('md-home-mortgage.getMoreInfo')"
                />
            </teleport>
            <Disclaimer
                v-else
                :color="disclaimerColor"
                :disclaimerUniqId="disclaimerUniqId"
                @updateChecked="checked => (disclaimerChecked = checked)"
                :btnText="$t('md-home-mortgage.getMoreInfo')"
            />
        </template>
    </div>
</template>
<script>
import util from '@/common/util.js';
import Disclaimer from '@/components/disclaimer';
import message from '../mixins/message';
import inputItem from '../components/input-item';
import { openLoginHideOtherPop } from '@/components/sign-log';
export default {
    mixins: [message],
    components: { inputItem, Disclaimer },
    i18next: {
        ns: 'md-home-mortgage'
    },
    props: {
        leadFormTitle: {
            type: String,
            required: true
        },
        nameFormat: {
            type: String,
            required: true
        },
        requirePhone: {
            type: Boolean,
            default: false
        },
        showDisclaimer: {
            type: Boolean,
            default: true
        },
        disclaimerColor: {
            type: String,
            default: ''
        },
        disclaimerTeleportId: {
            type: String,
            default: ''
        },
    },
    data: function() {
        return {
            infoTextShow: false,
            submitDisabled: false,
            disclaimerChecked: true,
            disclaimerUniqId: util.uuidv4()
        };
    },
    computed: {
        disabledBtn() {
            return this.submitDisabled || !this.disclaimerChecked;
        },
        items() {
            let readonly = !!this.user;
            let formitems = [
                {
                    name: 'email',
                    placeholder: this.$t('common:email') + '*',
                    type: 'email',
                    required: true,
                    readonly: readonly,
                    value: (this.user && this.user.account) || '',
                    validateConfig: {
                        async: '/api-site/register/hasUser?account={value}',
                        'async-callback': this.hasUserCallBack
                    }
                },
                {
                    name: 'phone',
                    placeholder:
                        this.$t('common:phone') +
                        (this.requirePhone ? '*' : ''),
                    type: 'tel',
                    required: this.requirePhone,
                    readonly: readonly,
                    value: (this.user && this.user.phoneNumber) || '',
                    validateConfig: {
                        async: '/api-site/phoneValidate?phoneNumber={value}'
                    }
                }
            ];
            if (this.nameFormat == 'fullname') {
                formitems.unshift({
                    name: 'fullname',
                    placeholder: this.$t('common:fullName'),
                    type: 'text',
                    readonly: readonly,
                    value: (this.user && this.user.fullName) || ''
                });
            } else {
                formitems.unshift(
                    {
                        name: 'firstName',
                        placeholder: this.$t('common:firstName'),
                        type: 'text',
                        readonly: readonly,
                        class: 'half mg-20',
                        value: (this.user && this.user.firstName) || ''
                    },
                    {
                        name: 'lastName',
                        placeholder: this.$t('common:lastName'),
                        type: 'text',
                        readonly: readonly,
                        class: 'half',
                        value: (this.user && this.user.lastName) || ''
                    }
                );
            }
            return formitems;
        }
    },
    watch: {
        user(value) {
            if (!value) {
                this.infoTextShow = false;
            }
        }
    },
    methods: {
        registerSubmitSuccess(data = {}) {
            this.submitDisabled = true;
            setTimeout(() => {
                this.submitDisabled = false;
            }, 3000);
            this.formatData(data);
            if (this.user) {
                this.leaveMessage(this.onSuccessCallback);
            } else {
                this.leadRegister();
            }
        },
        registerNext() {
            if (this.inquiry) {
                this.showQuestionnaire(
                    Object.assign({}, this.questionnaire || {}, {
                        noToast: true,
                        closeCallback: () => {
                            this.onSuccessCallback();
                        }
                    })
                );
            } else {
                this.onSuccessCallback();
            }
        },
        onSuccessCallback() {
            this.infoTextShow = true;
        },
        hasUserCallBack(flag, error, value) {
            if (
                !flag && error?.code === 210003
            ) {
                setTimeout(() => {
                    openLoginHideOtherPop({}, value);
                }, 1000);
            }
        }
    }
};
</script>
<style lang="scss">
@import '../theme/media.scss';
@import '../theme/mixin.scss';
.broker-lead-form {
    width: 310px;
    padding: 30px 20px;
    background: #f7f7f7;
    border-top: 4px solid var(--color-theme);
    border-radius: 5px;
    .label-top {
        display: none;
    }
    .lead-title {
        font-size: 16px;
        color: #191919;
        margin-bottom: 20px;
        text-align: center;
        font-family: var(--font-bold);
    }
    .lead-info {
        width: 100%;
        height: 244px;
        background-color: rgba(255, 255, 255, 0.2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 5px;
        .iconfont {
            width: 40px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 50%;
            overflow: hidden;
            position: relative;
            &::before {
                font-size: 22px;
                font-weight: bold;
                @include color-theme();
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .text {
            font-size: 16px;
            font-family: var(--font-bold);
            color: #191919;
            line-height: 24px;
            text-align: center;
            margin-top: 20px;
        }
    }
    form {
        &::after {
            content: '';
            clear: both;
            display: block;
        }
        @include placeholderMix(var(--font-normal), #a8a8a8, 13px);
        input[type='text'],
        input[type='email'],
        input[type='tel'] {
            font-size: 12px;
            width: 100%;
            height: 36px;
            padding: 0px 11px;
            border-radius: 5px;
            box-shadow: none;
            border: none;
        }
        .input-box,
        .v-input {
            margin-bottom: 20px;
            float: left;
            width: 100%;
            &.half {
                width: calc(50% - 10px);
            }
            &.mg-20 {
                margin-right: 20px;
            }
        }

        .approve {
            margin-top: 18px;
            margin-bottom: 30px;
            .approve-checkbox {
                margin: 0;
                vertical-align: top;
            }
            .approve-text {
                color: white;
                font-size: 13px;
            }
        }

        .submit {
            background-color: var(--color-theme);
            color: white;
            font: 16px var(--font-bold);
            height: 40px;
            width: 100%;
            border-radius: 20px;
        }
        input.submit-disabled {
            cursor: not-allowed;
            opacity: 0.4;
        }
    }
}
@include media-600 {
    .broker-lead-form {
        width: 100%;
    }
}
</style>
